import EventType from 'ol/events/EventType.js';
import MapBrowserEvent from 'ol/MapBrowserEvent.js';
import CustomInteractionLifecycle from './CustomInteractionLifecycle';
import Point from 'ol/geom/Point';
import { Renderer } from './Renderer';
import * as _ from 'lodash'
import { WaypointsEntity } from './WaypointEntity';
import WaypointFeature from './WaypointFeature';
import PreUndoEvent from './PreUndoEvent';
import DeleteWaypointData from './DeleteWaypointData';
import EventRememberingPointerInteraction from './EventRememberingPointerInteraction';
import {Options} from 'ol/interaction/Pointer.js';
import WaypointOptions from './WaypointOptions';

export interface DrawWaypointOptions {
    waypoint: WaypointsEntity;
    renderer: Renderer<any>;
}

export default class DrawWaypoint extends EventRememberingPointerInteraction implements CustomInteractionLifecycle {
    options: DrawWaypointOptions

    constructor(options: DrawWaypointOptions, pointerOptions?: Options) {
        super(pointerOptions)

        this.options = options
        this.setCursor('crosshair')
    }
    implementsCustomInteractionLifecycle = true

    finish(): void {
        this.setCursor('default')
    }

    setCursor(cursorType: string) {
        const targetElement = this.options.renderer.map.getTargetElement();
        if(targetElement) { // it's sometimes null, not sure why
            targetElement.style.cursor = cursorType
        }
    }

    handleEvent(event: MapBrowserEvent<any>) {
        if (event.originalEvent.type === EventType.CONTEXTMENU) {
            // Avoid context menu for long taps when drawing on mobile
            event.preventDefault();
        }

        if(event.type === 'singleclick') {
            return this.handleSingleClick(event)
        } else if(event.type === 'pointermove') {
            return this.handlePointerMove(event)
        }

        return super.handleEvent(event)
    }

    handlePointerMove(event: MapBrowserEvent<any>) {
        if(!this.options.renderer.map.getFeaturesAtPixel(event.pixel).some((f: any) => f instanceof WaypointFeature) &&
           !this.options.renderer.mapInstanceState.draggingWaypoint) {
            this.setCursor('crosshair')
        }
        return true // true means DO pass it on to another interaction, e.g. editwaypoint
    }

    handleSingleClick(event: MapBrowserEvent<any>) {
        if(!this.options.renderer.map.getFeaturesAtPixel(event.pixel, WaypointOptions.atPixelOptions).some((f: any) => f instanceof WaypointFeature)) {
            // don't add a new one if potentially trying to select an existing one
            const newIndex = this.options.waypoint.dotsFeatureSource.getFeatures().length
            const waypointFeature = new WaypointFeature(new Point(event.coordinate), this.options.waypoint, newIndex)
            this.dispatchEvent(new PreUndoEvent([new DeleteWaypointData(waypointFeature.value)], 'add waypoint'))
            this.options.waypoint.dotsFeatureSource.addFeature(waypointFeature)
        }
        return true
    }
}
